import { REDUCER_NAME } from './const'

export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}

export const selectEmployee = (state) => {
    return selectOwnState(state).employee
}

export const selectSipGateDeviceId = (state) => {
    const employee = selectEmployee(state)
    return employee.sipGateDeviceId
}



// WEBPACK FOOTER //
// ./src/modules/employee/state/selector.js